// src/i18n/en/scope.ts
// English mirror of es/scope.ts.
export const scope = {
  pill: {
    all: 'All hotels',
    one: '1 hotel',
    many: '%{count} hotels',
    ofTotal: '%{count} of %{total} hotels',
  },
  search: {
    placeholder: 'Search hotel…',
  },
  group: {
    allHotels: 'all hotels',
  },
  footer: {
    selectedCount: '%{count} selected',
    all: 'All',
    clear: 'Clear all',
    pickOne: 'Tick at least one hotel',
  },
  remembered: 'The selection is remembered per user.',
};

export default scope;
